import { render, staticRenderFns } from "./AddOffSet.vue?vue&type=template&id=0afd3c9c&scoped=true"
import script from "./AddOffSet.vue?vue&type=script&lang=js"
export * from "./AddOffSet.vue?vue&type=script&lang=js"
import style0 from "./AddOffSet.vue?vue&type=style&index=0&id=0afd3c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afd3c9c",
  null
  
)

export default component.exports